import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAsyncFn } from "../../hooks/use-async-fn";
import config from "../../config";
import { OnamLanding } from "../../onam/hub/OnamHub";
import { useFederation } from "../FederationSelection/FederationContext";

const Orbit = ({ authContext }) => {
  const [, setLogoLoaded] = useState(false);
  const { getApplication } = authContext;
  const getApplicationFn = useAsyncFn({
    promiseFn: getApplication,
  });
  var applicationData = getApplicationFn.data && getApplicationFn.data;
  const logoUrl = applicationData?.logo;
  const landingPage = applicationData?.landing_page;
  localStorage.clear();
  const { setFedId, setPlatformLogo } = useFederation();
  const { appMetadata, getPermissionsbyrole } = authContext;
  let tenantObj = {};
  tenantObj = appMetadata && Object.values(appMetadata);

  var authRole = tenantObj[0]?.roles[0];
  const organizationId = tenantObj[0].organization;
  var sessionOrganizationId = organizationId;
  localStorage.setItem("organizationkey", sessionOrganizationId);
  localStorage.setItem("authRole", authRole);
  const getPermissionsbyroleFn = useAsyncFn({
    promiseFn: getPermissionsbyrole,
    userRole: authRole,
  });

  const requiredPages = [
    "createfederation",
    "campaignplanning",
    "query",
    "provenancetrail",
    "activationhistory",
    "activationconnectors",
    "datamanager",
  ];
  const apiPermissions = getPermissionsbyroleFn?.data?.rbacGroupName || [];

  const finalPermissions = requiredPages.map((page) => {
    const match = apiPermissions.find((perm) => perm.startsWith(`${page}_`));
    return match || `${page}_no_access`;
  });

  const permissionsObj = {};

  const roles = getPermissionsbyroleFn?.data?.roles || [];
  const metadataRoles = tenantObj[0]?.roles || [];

  const isSuperUserReadOnly =
    metadataRoles.includes(config.superUserRole) &&
    metadataRoles.includes("read_only");

  if (isSuperUserReadOnly) {
    Object.assign(permissionsObj, {
      createfederation: "full",
      campaignplanning: "no",
      query: "no",
      provenancetrail: "read",
      activationhistory: "no",
      activationconnectors: "no",
      datamanager: "no",
    });
    localStorage.setItem("isSuperUserReadOnly", "true");
  } else if (
    roles.includes(config.superUserRole) ||
    roles.includes("organization_admin")
  ) {
    Object.assign(permissionsObj, {
      createfederation: "full",
      campaignplanning: "read",
      query: "full",
      provenancetrail: "read",
      activationhistory: "full",
      activationconnectors: "full",
      datamanager: "full",
    });
    localStorage.removeItem("isSuperUserReadOnly");
  } else {
    finalPermissions.forEach((perm) => {
      const [page, accessType] = perm.split("_");
      permissionsObj[page] = accessType;
    });
    localStorage.removeItem("isSuperUserReadOnly");
  }

  localStorage.setItem("userPermissions", JSON.stringify(permissionsObj));
  localStorage.setItem("userRole", roles);

  const history = useHistory();

  // Map old landing page values to new ones (case-insensitive)
  const landingPageMap = {
    landingpage2: "entry-hub",
  };

  // FederationProvider state: set after render, not during it
  useEffect(() => {
    setFedId(null);
    setPlatformLogo(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let timer;
    if ((getApplicationFn.error as Error)?.message?.startsWith("ORG_APP_MISMATCH:")) {
      return;
    }

    if (!getApplicationFn.data && !getApplicationFn.error) {
      return;
    }

    const normalizedLandingPage = landingPage?.toLowerCase() || "";
    const mappedLandingPage =
      landingPageMap[normalizedLandingPage] || landingPage;

    if (
      mappedLandingPage === "home" ||
      !mappedLandingPage ||
      mappedLandingPage === ""
    ) {
      timer = setTimeout(() => {
        history.push(`/entry-hub`);
      }, 2500);
    } else {
      timer = setTimeout(() => {
        history.push(`/${mappedLandingPage}`);
      }, 2);
    }

    return () => clearTimeout(timer);
  }, [history, landingPage, getApplicationFn.error, getApplicationFn.data]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!logoUrl) return;

    const img = new Image();
    img.src = logoUrl;
    img.onload = () => setLogoLoaded(true);
    img.onerror = () => setLogoLoaded(false);
  }, [logoUrl]);

  if (applicationData?.logo) {
    localStorage.setItem("logo", applicationData.logo);
  }

  useEffect(() => {
    localStorage.setItem("federationkey", JSON.stringify(null));
    localStorage.setItem("federationname", "");
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "configScope",
      applicationData?.setting?.toLowerCase(),
    );
    // ONAM: the tab icon stays the ONAM mark (public/index.html), not the application logo
  }, [applicationData]);

  // ONAM look: the grid mark steps round while MAP works out where to send you
  return <OnamLanding />;
};

export default Orbit;
